export const DEFAULT_CURRENCY_PREFIX = 'UGX';
export const APP_CURRENCY_STORAGE_KEY = 'app_currency_prefix';

export interface FormatAppCurrencyOptions {
  compactDisplay?: 'short' | 'long';
  currencyPrefix?: string | null;
  fromMinorUnits?: boolean;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
  notation?: 'standard' | 'scientific' | 'engineering' | 'compact';
}

export const setStoredAppCurrencyPrefix = (
  currencyPrefix?: string | null,
): void => {
  if (typeof window === 'undefined') return;

  if (!currencyPrefix?.trim()) {
    window.localStorage.removeItem(APP_CURRENCY_STORAGE_KEY);
    return;
  }

  window.localStorage.setItem(APP_CURRENCY_STORAGE_KEY, currencyPrefix.trim());
};

export const getAppCurrencyPrefix = (): string =>
  typeof window === 'undefined'
    ? DEFAULT_CURRENCY_PREFIX
    : window.localStorage.getItem(APP_CURRENCY_STORAGE_KEY)?.trim() ||
      DEFAULT_CURRENCY_PREFIX;

export const formatAppCurrency = (
  amount: number,
  options: FormatAppCurrencyOptions = {},
): string => {
  const value = options.fromMinorUnits ? amount / 100 : amount;
  const currencyPrefix =
    options.currencyPrefix?.trim() || getAppCurrencyPrefix();

  return `${currencyPrefix} ${new Intl.NumberFormat('en-US', {
    compactDisplay: options.compactDisplay,
    maximumFractionDigits: options.maximumFractionDigits ?? 0,
    minimumFractionDigits: options.minimumFractionDigits ?? 0,
    notation: options.notation ?? 'standard',
  }).format(value)}`;
};

export const formatAppNumber = (
  value: number,
  options?: Intl.NumberFormatOptions,
): string =>
  new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 0,
    ...options,
  }).format(value);
